export function formatDecimalString(value: string): string {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
